import { Text } from '@cinch-labs/design-system'

export const Copyright = () => (
  <Text fontSizeFixed="xs" color="pureWhite">
    &copy; {new Date().getFullYear()} Cinch Cars Limited. All rights reserved.
  </Text>
)
